import React from "react";
import "./CubeLogo.scss";

import { NavLink } from "react-router-dom";

const images = [
  "https://mir-s3-cdn-cf.behance.net/projects/202/42087777127127.Y3JvcCwxNjU0LDEyOTMsMCwyMA.jpg",
  "https://mir-s3-cdn-cf.behance.net/projects/202/3a9a7672036877.Y3JvcCwxMjE5LDk1Myw4NCw5.jpg",
  "https://mir-s3-cdn-cf.behance.net/projects/202/97cc7a68889037.Y3JvcCw5NjksNzU4LDIxNiw0NDQ.jpg",
  "https://mir-s3-cdn-cf.behance.net/projects/202/3a9a7672036877.Y3JvcCwxMjE5LDk1Myw4NCw5.jpg"
];

const Showcase = ({ images, size }) => (
  <div className="Showcase" style={{ width: `${images.length * size}px` }}>
    {images &&
      images.map((image, i) => (
        <div
          key={i}
          className="image"
          style={{
            backgroundImage: `url(${image})`,
            width: size,
            left: `${size * i}px`
          }}
        />
      ))}
  </div>
);

const CubeLogo = ({ size, showcase, gif }) => (
  <NavLink
    to="/"
    className="CubeLogo"
    data-showcase={showcase}
    data-gif={gif ? true : false}
    style={{ width: size, height: size, fontSize: size / 2 }}
  >
    <span>B</span>
    {showcase && <Showcase size={size} images={images} />}
    {gif && <div className="GIF" style={{ backgroundImage: `url(${gif})` }} />}
  </NavLink>
);

export default CubeLogo;
